<div
  (appClickOutside)="closeHelp()"
  class="btn-help">
  @if (showHelp) {
    <div class="help-content shadow-lg rounded">
      <div class="help-content__title">Recommended</div>
      <div class="d-flex flex-column">
        @for (faq of faqDetails; track faq.id; let i = $index) {
          <div class="pb-3">
            <button
              class="help-content__question-header"
              (click)="toggleCollapse(i)"
              [class.expanded]="expandedIndex === i"
              type="button"
              aria-controls="collapseExample">
              {{ faq.question }} <i class="iconoir-nav-arrow-right"></i>
            </button>
            <div
              [id]="'collapse-' + i"
              [ngbCollapse]="expandedIndex !== i"
              aria-labelledby="collapseExample"
              class="collapse help-content__answer">
              @if (faq.answer) {
                <div>
                  <markdown [data]="faq.answer"></markdown>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <hr />
      <div class="d-flex flex-column">
        <a
          [href]="helpCenterUrl"
          id="contactSupportBtn"
          target="_blank"
          rel="noopener"
          class="help-center-link">
          Help Centre <i class="iconoir-arrow-up-right"></i>
        </a>
      </div>
    </div>
  }

  <button
    id="helpBtn"
    class="btn btn-secondary text-white rounded-pill"
    (click)="showHelpChange()">
    <i [ngClass]="showHelp ? 'iconoir-xmark' : 'iconoir-help-circle fs-4'"></i>
    <span>{{ showHelp ? 'Close' : 'Help' }}</span>
  </button>
</div>
